import { ErrorResponse, ServerError } from '~/infra/ErrorResponse';
export const blockingErrorKindFrom = (err)=>{
    const errorResponse = new ErrorResponse(err);
    if (errorResponse.hasServerError(ServerError.BulkImportUnreadableFile)) return 'unreadableFile';
    if (errorResponse.hasServerError(ServerError.BulkImportMissingColumns)) return 'missingColumns';
    if (errorResponse.hasServerError(ServerError.BulkImportTooLarge)) return 'tooLarge';
    if (errorResponse.hasServerError(ServerError.BulkImportEmptyFile)) return 'emptyFile';
    return null;
};
